const PDF_RETRY_DEFAULT_SECONDS = 5

const PDF_STATE = Object.freeze({
  READY: 'ready',
  COOLDOWN: 'cooldown',
  NOT_READY: 'not_ready',
  FAILED: 'failed',
  UNKNOWN: 'unknown',
})

const VALID_PDF_STATES = new Set(Object.values(PDF_STATE))

function normalizeRetryAfterSeconds(value, fallback = null) {
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback
  }

  return Math.ceil(parsed)
}

function normalizeLastCheckedAt(value) {
  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return trimmed || null
}

export function resolveIssuedPdfState(issuedPdf = {}) {
  const rawState = typeof issuedPdf?.state === 'string' ? issuedPdf.state.trim().toLowerCase() : ''
  if (VALID_PDF_STATES.has(rawState)) {
    return rawState
  }

  if (issuedPdf?.available === true) {
    return PDF_STATE.READY
  }

  if (issuedPdf?.available === false) {
    return PDF_STATE.NOT_READY
  }

  return PDF_STATE.UNKNOWN
}

export function resolveIssuedPdfReadiness(issuedPdf = {}, nowMs = Date.now()) {
  const state = resolveIssuedPdfState(issuedPdf)
  const retryAfterSeconds = normalizeRetryAfterSeconds(issuedPdf?.retryAfterSeconds, null)
  const retryAfterEffectiveSeconds = normalizeRetryAfterSeconds(
    retryAfterSeconds,
    PDF_RETRY_DEFAULT_SECONDS,
  )
  const lastCheckedAt = normalizeLastCheckedAt(issuedPdf?.lastCheckedAt)
  const checkedAtMs = lastCheckedAt ? Date.parse(lastCheckedAt) : NaN
  const hasCheckedAt = Number.isFinite(checkedAtMs)

  let remainingSeconds = 0
  if (state === PDF_STATE.COOLDOWN) {
    if (hasCheckedAt) {
      const elapsedSeconds = Math.max(0, (Number(nowMs) - checkedAtMs) / 1000)
      remainingSeconds = Math.max(0, Math.ceil(retryAfterEffectiveSeconds - elapsedSeconds))
    } else {
      remainingSeconds = retryAfterEffectiveSeconds
    }
  }

  const isCooldownActive = state === PDF_STATE.COOLDOWN && remainingSeconds > 0

  return {
    state,
    reason: isCooldownActive ? PDF_STATE.COOLDOWN : state,
    available: Boolean(issuedPdf?.available),
    retryAfterSeconds,
    retryAfterEffectiveSeconds,
    lastCheckedAt,
    remainingSeconds,
    isCooldownActive,
  }
}

export function resolveInvoiceIssuedPdfReadiness(invoice = {}, nowMs = Date.now()) {
  return resolveIssuedPdfReadiness(invoice?.artifacts?.issuedPdf || {}, nowMs)
}

export { PDF_RETRY_DEFAULT_SECONDS, PDF_STATE }
